<template>
  <div class="mobile-login-root" :style="mobileLoginRootStyle">
    <img class="login-page-bg" src="@/assets/img/mobile/login-bg-top.png" />
    <div class="login-page" ref="loginPage">
      <div class="hello">
        <img class="login-logo" src="@/assets/img/mobile/logo.png" />
        <img class="login-welcome" src="@/assets/img/mobile/welcome.png" />
      </div>
      <div class="cui-main">
        <div class="login-form">
          <!--用户名密码登录-->
          <template v-if="loginType == 1">
            <div class="account">
              <input v-model="loginForm.username" :placeholder="$t('login.txt011')" maxlength="30" />
              <img class="secrecy" @click.stop="clear" src="@/assets/img/mobile/icon-clear.png" v-if="loginForm.username" />
            </div>
            <div class="password">
              <input v-model="loginForm.password" :type="passwordType" :placeholder="$t('login.txt012')" />
              <img class="secrecy secrecyBox" :src="getIconEye" @click="showPassword" />
            </div>
          </template>
          <!--手机号验证码登录-->
          <template v-else>
            <div class="account">
              <input v-model="loginForm.phoneNum" type="number" :placeholder="$t('login.txt011-2')" />
              <img class="secrecy" @click.stop="clear" src="@/assets/img/mobile/icon-clear.png" v-if="loginForm.phoneNum" />
            </div>
            <div class="password checkCode">
              <input v-model="loginForm.verifyCode" type="number" :placeholder="$t('login.txt013-2')" maxlength="6" @input="validateRange" />
              <van-button class="code-btn" size="mini" round @click="sendSmsVerifyCode" color="linear-gradient(90deg, #4776F0 0%, #3062E1 100%)">
                <span v-if="isFinished">{{ $t('login.txt025') }}</span>
                <template v-else>
                  <van-count-down ref="countDown" :time="time" @finish="countDownFinished">
                    <template #default="timeData">
                      <span class="color-white">{{ timeData.seconds }}s</span>
                    </template>
                  </van-count-down>
                </template>
              </van-button>
            </div>
          </template>
        </div>
        <!-- 我已阅读并同意隐私政策 -->
        <div class="regist-tips">
          <van-checkbox v-model="checked" label-class="agree-protocol" checked-color="#3062e1">{{$t('login.txt004')}}</van-checkbox>
          <span class="agreement primary-color" @click="toPolicyPage('https://fssccloud.ciicpt.com.cn/privacyPolicy.action')">{{$t('login.txt005')}}</span>
        </div>
        <!--登录按钮-->
        <div class="login-button">
          <van-button class="full-button" block round @click="doLogin" color="linear-gradient(90deg, #4776F0 0%, #3062E1 100%)">{{$t('login.txt003')}}</van-button>
        </div>
      </div>
      <!-- 登录方式图标展示 -->
      <div class="login-button-types">
        <div class="type-header">
          <van-divider content-position="center" custom-style="font-size: 22rpx">其他登录方式</van-divider>
        </div>
        <div class="type-footer">
          <img class="footer--img" src="@/assets/img/mobile/login-type-code.png" @click="checkTypeChange(2)" v-if="loginType == 1" />
          <img class="footer--img" src="@/assets/img/mobile/login-type-username.png" @click="checkTypeChange(1)" v-if="loginType == 2" />
        </div>
      </div>
    </div>
    <img class="bottom-bg" src="@/assets/img/mobile/login-bg-bottom.png" ref="bottomBg" />
    <van-popup class="login-page" v-model="validCodeShow" round :style="popupStyle" :close-on-click-overlay="false" @opened="onValidCodeOpened">
      <div class="login-form" style="text-align: center">
        <div class="code-container">
          <el-image class="mobile-code-img" :src="imageUrl" fit="cover"></el-image>
          <span class="change-code primary-color" @click="refreshCode">换一张</span>
        </div>
        <div class="account">
          <input v-model="loginForm.validCode" auto-complete="off" :placeholder="$t('login.txt013')" maxlength="4" style="width: 100%; margin-right: 0;" />
        </div>
        <div class="popup-btn-group">
          <van-button class="popup-btn" round @click="validCodeShow = false">取消</van-button>
          <van-button class="popup-btn" round color="linear-gradient(90deg, #4776F0 0%, #3062E1 100%)" @click="validCodeConfirm">确定</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import Logo from '@/assets/img/mobile/logo.png'
  import { Toast } from 'vant';
  import { validatenull, isvalidatemobile } from '@/util/validate';
  import { sendSmsVerifyCode } from '@/api/user/login'
  import {filterNullValue} from "@/util/commen";

  export default {
    computed: {
      // 将 login-page + bottom-bg 的“渲染高度”之和，用作 mobile-login-root 的最小高度
      loginPageContentHeight() {
        if (!this.domReady) return 0
      
        const el = this.$refs.loginPage
        if (!el) return 0
      
        // offsetHeight：可视区域真实渲染高度
        // 通过 heightVersion * 0 让 computed 在图片加载后重新评估（不改变高度值）
        return (el.offsetHeight || 0) + this.heightVersion * 0
      },
      bottomBgContentHeight() {
        if (!this.domReady) return 0
      
        const el = this.$refs.bottomBg
        if (!el) return 0
      
        // 通过 heightVersion * 0 让 computed 在图片加载后重新评估（不改变高度值）
        return (el.offsetHeight || 0) + this.heightVersion * 0
      },
      mobileLoginRootStyle() {
        const totalHeight = (this.loginPageContentHeight || 0) + (this.bottomBgContentHeight || 0)
        if (!totalHeight) return {}
        return { minHeight: `${totalHeight}px` }
      },
      getIconEye() {
        if (this.passwordType == "password") {
          return require("@/assets/img/mobile/icon-eye-close.png")
        } else {
          return require("@/assets/img/mobile/icon-eye-open.png")
        }
      }
    },
    data() {
      return {
        Logo,
        domReady: false,
        heightVersion: 0,
        loginForm: {
          username: "",
          validCode: '',
          password: "",
          phoneNum: "",
          verifyCode: "",
          targetSys: "hoseh5"
        },
        isFinished: true,
        time: 60000,
        checked: false,
        loading: true,
        passwordType: 'password',
        loginType: 2,
        imageUrl:'/api/image-code/code',
        validCodeShow: false,
        popupStyle: {
          width: '5.3rem',
          padding: '0.5rem'
        }
      }
    },
    mounted() {
      // dom 结构渲染完成后再计算一次；图片资源加载完成后也会触发重算
      this.$nextTick(() => {
        this.domReady = true
        this.heightVersion++
      
        const trigger = () => {
          this.heightVersion++
        };
      
        // bottom-bg 本身的高度依赖图片加载
        const bottomBg = this.$refs.bottomBg
        if (bottomBg) {
          if (bottomBg.complete) {
            trigger()
          } else {
            bottomBg.addEventListener("load", trigger, { once: true })
          }
        }
      
        // login-page 内部也包含若干图片，加载完成后高度可能变化
        const loginPage = this.$refs.loginPage;
        if (loginPage) {
          const imgs = loginPage.querySelectorAll("img")
          imgs.forEach(img => {
            if (img.complete) return
            img.addEventListener("load", trigger, { once: true })
          });
        }
      });
    },
    methods: {
      toPolicyPage(url) {
        window.location.href = url
      },
      // 清除账号/手机号
      clear() {
        if (this.loginType === 1) {
          this.loginForm.username = '';
        } else {
          this.loginForm.phoneNum = '';
        }
      },
      showPassword() {
        this.passwordType == '' ? (this.passwordType = 'password') : (this.passwordType = '');
      },
      // 切换登录方式
      checkTypeChange(val) {
        this.loginType = val;
        this.loginForm.username = "";
        this.loginForm.validCode = "";
        this.loginForm.password = "";
        this.loginForm.phoneNum = "";
        this.loginForm.verifyCode = "";
        this.loginForm.loginType = String(val);
      },
      // 刷新验证码
      refreshCode() {
        const num = Math.floor(Math.random() * (10000 - 10 + 1)) + 10;
        this.imageUrl = "/api/image-code/code?num=" + num;
        this.$forceUpdate();
      },
      // 弹窗打开时刷新验证码
      onValidCodeOpened() {
        this.loginForm.validCode = '';
        this.refreshCode();
      },
      // 输入验证码后确认登录
      validCodeConfirm() {
        const code = (this.loginForm.validCode || '').trim();
        if (!code) {
          Toast(this.$t('login.txt018'));
          return;
        }
        if (code.length !== 4) {
          Toast(this.$t('login.txt019'));
          return;
        }
        this.validCodeShow = false;
        this.submitLogin();
      },
      validateRange(e) {
        // 防止用户输入超范围后保留无效值
        // if (this.value > 99999) this.value = 99999;
        // if (this.value < 0) this.value = 0;
        let value = e.target.value.replace(/\D/g, ''); // 过滤非数字
        if (value.length > 6) value = value.slice(0, 6); // 限制长度为6位
        if (parseInt(value, 10) > 999999) value = '999999'; // 限制最大值
        if (parseInt(value, 10) < 0) value = '0';         // 限制最小值
        e.target.value = value;                          // 更新输入框值
        this.loginForm.verifyCode = value;               // 同步绑定数据
      },
      // 获取验证码
      sendSmsVerifyCode() {
        if (this.isFinished) {
          if (isvalidatemobile(this.loginForm.phoneNum)[0]) {
            Toast(isvalidatemobile(this.loginForm.phoneNum)[1])
          } else {
            sendSmsVerifyCode({ phoneNum: this.loginForm.phoneNum })
            .then(() => {
              Toast(this.$t('login.txt023'))
              this.$set(this, 'time', 60000);
              this.isFinished = false
              if (this.$refs.countDown) {
                this.isFinished = false
                this.$refs.countDown.start();
              }
            })
            .catch(() => {
              Toast(this.$t('login.txt024'))
              //this.countDownFinished();
              this.$set(this, 'time', 10000);
              this.isFinished = false
              if (this.$refs.countDown) {
                this.$refs.countDown.start();
              }
            })

          }
        }
      },
      // 倒计时结束
      countDownFinished() {
        this.isFinished = true
      },
      // 表单验证 - 账号密码登录(loginType=1)
      validateFormForUsername() {
        if (validatenull(this.loginForm.username)) {
          Toast(this.$t('login.txt016'))
          return false
        }
        if (validatenull(this.loginForm.password)) {
          Toast(this.$t('login.txt017'))
          return false
        }
        if (!this.checked) {
          Toast(this.$t('login.txt014'))
          return false
        }
        return true
      },
      // 表单验证 - 手机号验证码登录(loginType=2)
      validateFormForPhone() {
        if (validatenull(this.loginForm.phoneNum)) {
          Toast(this.$t('login.txt011-2'))
          return false
        }
        if (validatenull(this.loginForm.verifyCode)) {
          Toast(this.$t('login.txt018'))
          return false
        }
        if (isvalidatemobile(this.loginForm.phoneNum)[0]) {
          Toast(isvalidatemobile(this.loginForm.phoneNum)[1])
          return false
        }
        if (this.loginForm.verifyCode.length < 6) {
          Toast(this.$t('login.txt026'))
          return false
        }
        if (!this.checked) {
          Toast(this.$t('login.txt014'))
          return false
        }
        return true
      },
      // 登录
      doLogin() {
        if (this.loginType === 1) {
          // 账号密码登录：先验证表单，通过后弹出验证码弹窗
          if (this.validateFormForUsername()) {
            this.validCodeShow = true;
          }
        } else {
          // 手机号验证码登录：直接验证并提交
          if (this.validateFormForPhone()) {
            this.submitLogin();
          }
        }
      },
      // 提交登录请求
      submitLogin() {
        const toast = Toast.loading({
          forbidClick: true,
          overlay: true,
          message: this.$t('loading'),
          duration: 0
        });

        this.loginForm.loginType = String(this.loginType);
        const params = filterNullValue(this.loginForm);
        this.$store.dispatch("LoginByUsername", params).then((res) => {
          if (res.data.data.success == "false") {
            toast.clear();
            Toast(res.data.data.msg);
          } else {
            if (res.data.data.user.sysInterfaceFlag == "80600002") {
              if (res.data.data.fcsUrl) {
                window.location.replace(res.data.data.fcsUrl);
              } else {
                Toast("登录异常，请联系管理员！");
              }
            } else {
              this.$router.push({ path: "/index" });
              Toast(this.$t('login.txt015'));
            }
          }
        }).catch((error) => {
          toast.clear();
          if (error.data && error.data.data.msg) {
            Toast(error.data.data.msg);
          }
        });
      }
    }
  }
</script>
